// Copyright (c) Move Closer 2022.
import { DocumentNode } from 'graphql'
import gql from 'graphql-tag'

import { MagentoVersion } from '../../../../contexts'

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export const CUSTOMER_ORDERS_FRAGMENT = gql`
  fragment CustomerOrdersFragment on CustomerOrders {
    items {
      items {
        id
        product_sku
        product_name
        product_type
        product_url_key
        quantity_ordered
        product_sale_price {
          value
          currency
        }
      }
      number
      status
      status_code
      updated_at
      total {
        grand_total {
          value
          currency
        }
        shipping_handling {
          amount_including_tax {
            value
            currency
          }
        }
      }
    }
    total_count
  }
`

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 * @author Filip Rurak <filip.rurak@movecloser.pl> (edited)
 */
export const CUSTOMER_ORDERS_FRAGMENT_2_4 = gql`
  fragment CustomerOrdersFragment on CustomerOrders {
    items {
      ax_invoice_link
      items {
        id
        product_sku
        product_name
        product_type
        product_url_key
        quantity_ordered
        product_sale_price {
          value
          currency
        }
      }
      carrier
      number
      created_at
      updated_at
      billing_address {
          city
          company
          country_code
          fax
          firstname
          lastname
          middlename
          postcode
          prefix
          region
          region_id
          street
          suffix
          telephone
          vat_id
      }
      shipping_address {
        city
        company
        country_code
        fax
        firstname
        lastname
        middlename
        postcode
        prefix
        region
        region_id
        street
        suffix
        telephone
        vat_id
      }
      payment_method
      shipping_method
      status
      status_code
      total {
        discounts {
            amount {
                value
                currency
            }
            label
        }
        grand_total {
          value
          currency
        }
        shipping_handling {
          amount_including_tax {
            value
            currency
          }
        }
      }
    }
    total_count
  }
`

/**
 * @author Agnieszka Zawadzka <agnieszka.zawadzka@movecloser.pl>
 */
export const CUSTOMER_ORDERS_FRAGMENTS_MAP: Record<MagentoVersion, DocumentNode> = {
  [MagentoVersion.Default]: CUSTOMER_ORDERS_FRAGMENT,
  [MagentoVersion.Ver24]: CUSTOMER_ORDERS_FRAGMENT_2_4,
  [MagentoVersion.Enterprise]: CUSTOMER_ORDERS_FRAGMENT_2_4
}
